export const TravelViews = {
  hotels: "hotels",
  cars: "cars",
  activities: "activities",
  flights: "flights",
  parks: "parks",
  myTrips: "my-trips",
  retailers: "retailer",
  legacyParks: "parks",
  events: "events",
  parksSearch: "parks_search",
  dmoMarketing: "dmo",
};
